import { Type } from 'class-transformer';

export class BoardAnnouncementResultDto {
  @Type(() => Date)
  releaseDate: Date;
  subject: string;
  content: string;
}
